import { SVGFC } from '@repo/toolkit/types'

const BackIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.15119 5.61367H11.375C13.6532 5.61367 15.5 7.4605 15.5 9.73867C15.5 12.0168 13.6532 13.8637 11.375 13.8637H8.74799C8.33377 13.8637 7.99799 13.5279 7.99799 13.1137C7.99799 12.6995 8.33377 12.3637 8.74799 12.3637H11.375C12.8247 12.3637 14 11.1884 14 9.73867C14 8.28892 12.8247 7.11367 11.375 7.11367H6.15119L7.84435 8.80683C8.15188 9.11436 8.15188 9.61298 7.84435 9.92052C7.53681 10.2281 7.03819 10.2281 6.73065 9.92052L3.73065 6.92052C3.42312 6.61298 3.42312 6.11436 3.73065 5.80683L6.73065 2.80683C7.03819 2.49929 7.53681 2.49929 7.84435 2.80683C8.15188 3.11436 8.15188 3.61298 7.84435 3.92052L6.15119 5.61367Z"
        fill={color || 'currentColor'}
      />
    </svg>
  )
}

export default BackIcon
